import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const GET_ZONE_LOADING = 'GET_ZONE_LOADING';
export const GET_ZONE_SUCCESS = 'GET_ZONE_SUCCESS';
export const GET_ZONE_REJECT = 'GET_ZONE_REJECT';

//* ACTIONS ------------------------------------------------
export const getZoneLoading = () => ({ type: GET_ZONE_LOADING });
export const getZoneSuccess = (payload) => ({ type: GET_ZONE_SUCCESS, payload });
export const getZoneReject = (payload) => ({ type: GET_ZONE_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const getZoneRequest = async (params = {}, getState) => {
    const options = await withToken({
        method: Methods.GET,
        params,
    }, getState);
    return request(`/api/Zones`, options);
};

